import React, { Component } from 'react';
import { HashRouter as Router, Route, Switch, Redirect, } from 'react-router-dom';
import Login from './components/login';
import { notification, Button, message, Modal } from "antd";
import ES from "./components/admin";
import remind from "@/method/remind";

// 按需加载组件
import Bundle from './Bundle';
import request from './method/request';

const { confirm } = Modal;

function getCookie(c_name) {
    if (document.cookie.length > 0) {
        let c_start = document.cookie.indexOf(c_name + "=")
        if (c_start != -1) {
            c_start = c_start + c_name.length + 1
            let c_end = document.cookie.indexOf(";", c_start)
            if (c_end == -1) c_end = document.cookie.length
            return unescape(document.cookie.substring(c_start, c_end))
        }
    }
    return ""
}

// 按需加载配置
// 由于ES 按需加载会导致页面渲染两次，改为默认加载
// const App = (props) => (
//     <Bundle load={() => import('./components/admin')}>
//         {(Chat) => <Chat {...props} />}
//     </Bundle>
// );

const Bp = (props) => (
    <Bundle load={() => import('./bp-views/admin')}>
        {(Chat) => <Chat {...props} />}
    </Bundle>
);

const Hr = (props) => (
    <Bundle load={() => import('./hr/admin')}>
        {(Chat) => <Chat {...props} />}
    </Bundle>
);

const pay = (props) => (
    <Bundle load={() => import('./pay')}>
        {(Chat) => <Chat {...props} />}
    </Bundle>
);

const payres = (props) => (
    <Bundle load={() => import('./pay/PayResult')}>
        {(Chat) => <Chat {...props} />}
    </Bundle>
);

const PaySelect = (props) => (
    <Bundle load={() => import('./pay/PaySelect')}>
        {(Chat) => <Chat {...props} />}
    </Bundle>
);

class RouteComponent extends Component {
    state = {
        hotel: {},
        isAdmin: false,
        open: true,
    }

    componentDidMount() {
        this.getExpireDate();
    }

    onPay = (item) => {
        notification.close(item.id);
        window.location.href = item.path;
    }

    onNoPrompt = async (item) => {
        try {
            let data = await request(`/deleteNotice?id=${item.id}`);
            if (data.status == 1) {
                notification.close(item.id);
                return
            }

            message.error('关闭失败！');
        } catch (error) {
            console.error(error);
        }
    }
    getExpireDate = async () => {
        try {
            const d = await request('/getExpireDate?v=1.200813');
            const { hotel = {}, isAdmin, isReload, notice = [], chargeNotice } = d.data || {};
            this.setState({
                hotel: hotel,
                isAdmin: !!isAdmin
            });

            if (d.status == 5) {
                window.location.href = '/#/login';
                return
            }

            if (isReload) {
                window.location.reload();
            }

            for (let index = 0; index < notice.length; index++) {
                const ishotel = (notice[index].hotels || '').split(',').some(x => x == hotel.id);
                const item = notice[index];
                const that = this;
                if (ishotel && item.modal == 1) {
                    if (!item.path || `/${window.location.hash}` != item.path) confirm({
                        title: item.title,
                        // icon: <ExclamationCircleOutlined />,
                        content: <div className="home-richText" dangerouslySetInnerHTML={{ __html: item.content || "" }}></div>,
                        cancelText: item.isclose != 1 ? '不再提醒' : "我已知晓",
                        okText: item.button_name || "确定",
                        onOk() {
                            if (item.path && `/${window.location.hash}` != item.path) {
                                window.location.href = item.path
                            }
                        },
                        onCancel() {
                            item.isclose != 1 && that.onNoPrompt(item)
                        },
                    });
                } else if (ishotel) {
                    notification[item.type]({
                        message: item.title,
                        duration: null,
                        description: <div>
                            <div className="home-richText" dangerouslySetInnerHTML={{ __html: item.content || "" }}>

                            </div>
                            {item.button_name && <div style={{ margin: '20px 0 10px 0', textAlign: "center" }}>
                                <Button
                                    type="primary"
                                    onClick={() => this.onPay(item)}
                                >{item.button_name}</Button>
                            </div>}
                            {item.isclose != 1 && <div style={{ textAlign: 'center' }}>
                                <a onClick={this.onNoPrompt.bind(this, item)}>不再提醒</a>
                            </div>}

                        </div>,
                        key: item.id,
                    });
                }

            }

        } catch (error) {
            console.error(error);
        }
    }
    render() {
        let user = getCookie('user') || "{}";
        return (
            <Router>
                <div>
                    <Switch>

                        <Route path="/table" component={ES} />
                        <Route path="/bp" component={Bp} />
                        <Route path="/hr" component={Hr} />
                        <Route path="/login" component={Login} />
                        <Route path="/pay" component={pay} />
                        <Route path="/payselect" component={PaySelect} />
                        <Route path="/payresult/:code" component={payres} />

                        <Redirect from="/" to={user && !window.location.pathname.includes('table') ? "/table/cover" : "/login"} />
                    </Switch>
                </div>
            </Router>
        );
    }
}


export default RouteComponent;



// WEBPACK FOOTER //
// ./src/Route.js